export default __webpack_public_path__ + "static/media/JOSA CLASS-7 EXAM PATTERN 2026-27.a2cb00ca.pdf";